var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7656,
    cy: 25.75,
    r: 25,
    fill: "#9C4900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1094 15H16.6094C15.919 15 15.3594 15.5596 15.3594 16.25V21.25C15.3594 21.9404 15.919 22.5 16.6094 22.5H19.1094C19.7997 22.5 20.3594 21.9404 20.3594 21.25V16.25C20.3594 15.5596 19.7997 15 19.1094 15Z",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1094 35C35.4901 35 36.6094 33.8807 36.6094 32.5C36.6094 31.1193 35.4901 30 34.1094 30C32.7287 30 31.6094 31.1193 31.6094 32.5C31.6094 33.8807 32.7287 35 34.1094 35Z",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 17.5H32.8594C36.3106 17.5 39.1094 21.4175 39.1094 26.25V32.5H36.6094M31.6094 32.5H21.6094",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6094 17.5L33.4844 26.25H39.1094M23.4844 23.75H32.8594M26.6094 17.5V23.75M17.8594 22.5V36.25",
    stroke: "#F6EFE9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop_icon.be790050fabfdefa7747ef63274dfdce.svg";
export { ForwardRef as ReactComponent };